var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCountryPg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 20,
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2858_8975)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2C0 0.895431 0.895431 0 2 0H26C27.1046 0 28 0.895431 28 2V18C28 19.1046 27.1046 20 26 20H2C0.895431 20 0 19.1046 0 18V2Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2858_8975",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 20
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 2C0 0.895431 0.895431 0 2 0H26C27.1046 0 28 0.895431 28 2V18C28 19.1046 27.1046 20 26 20H2C0.895431 20 0 19.1046 0 18V2Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2858_8975)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 20,
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H28V20L0 0Z",
    fill: "#E8283F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.66659 16.6666L5.72378 16.9428L5.99992 16L5.72378 15.0572L6.66659 15.3333L7.60939 15.0572L7.33325 16L7.60939 16.9428L6.66659 16.6666Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.66659 8.66663L5.72378 8.94277L5.99992 7.99996L5.72378 7.05715L6.66659 7.33329L7.60939 7.05715L7.33325 7.99996L7.60939 8.94277L6.66659 8.66663Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.33333 12L2.39052 12.2761L2.66667 11.3333L2.39052 10.3905L3.33333 10.6667L4.27614 10.3905L4 11.3333L4.27614 12.2761L3.33333 12Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.33333 11.3334L8.39052 11.6095L8.66667 10.6667L8.39052 9.7239L9.33333 10L10.2761 9.7239L10 10.6667L10.2761 11.6095L9.33333 11.3334Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.8613 9.26553C18.7017 9.16976 18.5723 8.94416 18.5723 8.76367L18.5723 7.53495C18.5723 7.35355 18.4418 7.25 18.2443 7.31584L17.4861 7.56857C17.3049 7.62895 17.0275 7.6344 16.8301 7.56857L16.0718 7.31584C15.8907 7.25545 15.8706 7.13047 16.0329 7.03309L17.8118 5.9657C17.9715 5.86993 18.0574 5.66178 17.9915 5.46428L17.7388 4.70608C17.6784 4.52493 17.76 4.42158 17.9575 4.48741L18.7157 4.74014C18.8968 4.80053 19.1197 4.72275 19.2171 4.56046L20.2845 2.78147C20.3802 2.62185 20.5014 2.62297 20.5672 2.82046L20.82 3.57867C20.8803 3.75982 20.8858 4.03718 20.82 4.23467L20.5672 4.99288C20.5068 5.17403 20.6058 5.32088 20.7863 5.32088H22.0151C22.1965 5.32088 22.4195 5.44761 22.5169 5.6099L23.5843 7.38889C23.6801 7.54851 23.6031 7.70884 23.43 7.74345L21.7284 8.08376C21.5474 8.11996 21.3698 8.30396 21.3351 8.47704L20.9948 10.1786C20.9586 10.3596 20.8026 10.4303 20.6403 10.3329L18.8613 9.26553Z",
    fill: "#FFD84E"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2858_8975"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 2C0 0.895431 0.895431 0 2 0H26C27.1046 0 28 0.895431 28 2V18C28 19.1046 27.1046 20 26 20H2C0.895431 20 0 19.1046 0 18V2Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCountryPg);
export default __webpack_public_path__ + "static/media/Country=PG.ab2ddbbc477dbe4d9b76d1cdd35e7ca8.svg";
export { ForwardRef as ReactComponent };